import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\"><defs><style></style></defs><path d=\"M871.2 571c45.4-26.2 45.4-91.8 0-118L546.1 265.3 220.9 77.6c-45.4-26.2-102.2 6.6-102.2 59v750.8c0 52.5 56.8 85.3 102.2 59L546 758.7 871.2 571z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol